import { APIErrorResponse, EmployeeHolidayBalance } from '@/types'
import { UseQueryResult } from '@tanstack/react-query'
import { useQueryList } from '@/hooks/api/useQueryList'
import { QUERY_KEYS } from '@/constants'

export type HrInternalHoursHolidaysBalanceParams = {
  year?: number
  user?: string
}

export const useHrInternalHoursHolidaysBalance = (
  params: HrInternalHoursHolidaysBalanceParams = {},
  enabled = true
): UseQueryResult<EmployeeHolidayBalance[], APIErrorResponse> =>
  useQueryList({
    url: '/hours_reporting/hr/internal-hours/holidays-balance/',
    key: [...QUERY_KEYS.HR_INTERNAL_HOURS_HOLIDAYS_BALANCE, params],
    options: { enabled },
    params,
  })
